import { Table } from "rsuite-table";
import { useTable } from "react-table";
import React from "react";
import { rand, feeGenerate } from "./data";


const columns = [
    {
      Header: "요금",
      accessor: "요금",
    },
    {
      Header: "주변 주차장 평균요금",
      accessor: "주차장평균요금",
    },
    {
      Header: "내주차장 요금",
      accessor: "내주차장요금",
    },
  ];

  const data = [
    {
      요금: "평일",
    },
    {
      요금: "주말",
    },
    {
      요금: "일 정기권",
    },
    {
      요금: "월 정기권",
    },
  ];

export const Reacttable = () => {   
    
    var fee=[];
fee.push(sessionStorage.getItem("weekdayFee"));
fee.push(sessionStorage.getItem("weekendFee"));
fee.push(sessionStorage.getItem("dayPassFee"));
fee.push(sessionStorage.getItem("monthPassFee"));

data.forEach((val,idx)=>val.내주차장요금 = fee[idx]);
data.forEach((val,idx)=>val.주차장평균요금 = feeGenerate[idx]);

const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns,
    data,
  });
    return (
    <table {...getTableProps()}>
      <thead>
        {headerGroups.map((headerGroup) => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column) => (
              <th {...column.getHeaderProps()}>{column.render("Header")}</th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map((row, i) => {
          prepareRow(row);
          return (
            <tr {...row.getRowProps()}>
              {row.cells.map((cell) => {
                return <td {...cell.getCellProps()}>{cell.render("Cell")} </td>;
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}


